import { ref } from 'firebase/storage';
import { storage } from 'src/core/3rdParty/Firebase';

const userAvatarRef = (uid: string) => {
  return ref(storage, `user/${uid}/images/avatar.jpg`);
};

export { userAvatarRef };
